import React, { FC } from 'react'
import { SectionTitleWithIcon } from 'src/uikit'
import {
  Box,
  Container,
  useBreakpointValue,
  StyleProps,
} from '@chakra-ui/react'
import { useViewItemList, rentOfferToProductItem } from 'src/utils/gtm'
import Carousel from '../common/Carousel'
import { Offer } from '.'

interface Props {
  title?: string
  href?: string
  action?: string
  alt?: string
  offers: Array<OfferGlobal.RentOfferItem>
  target?: '_self' | '_blank'
  numPerView?: number
  w?: string | number
  bgColor?: string
  listId?: string
  listName?: string
  /** `false` quando la lista è in pagina ma nascosta: non è una lista vista. */
  trackView?: boolean
}

const HomeOffersList: FC<Props & StyleProps> = ({
  title,
  href,
  action,
  alt,
  offers,
  target,
  numPerView,
  w,
  bgColor,
  listId = 'home_nlt_offers',
  listName = 'Home — Offerte noleggio a lungo termine',
  trackView = true,
  ...others
}) => {
  const isMobile = useBreakpointValue({ base: true, md: false })

  const listItems = offers.map((offer, index) => rentOfferToProductItem(offer, { index }))

  useViewItemList({ items: listItems, listId, listName, enabled: trackView })

  return (
    <Box bgColor={bgColor || 'white'}>
      <Container as={Box} maxW={w || '8xl'} pt={10} {...others} id="offers-list-rent" px="0">
        {title && <SectionTitleWithIcon title={title} action={action} href={href} alt={alt} target={target} />}
        <Carousel
          withCustomNavigation={!isMobile}
          breakpoints={{
            320: {
              slidesPerView: 1.3,
              spaceBetween: 18,
              centeredSlides: true
            },
            480: {
              slidesPerView: 2,
              spaceBetween: 30
            },
            640: {
              slidesPerView: numPerView ? Math.ceil(numPerView / 2) : 3,
              spaceBetween: 30
            },
            1280: {
              slidesPerView: numPerView || 4,
              spaceBetween: 30
            }
          }}
          withScrollbar
          className={isMobile ? 'has-partial-slide' : null}
        >
          {offers.map((offer, index) => {
            return (
              <Carousel.Item key={offer.code}>
                <Offer
                  item={offer}
                  index={index}
                  listId={listId}
                  listName={listName}
                />
              </Carousel.Item>
            )
          })}
        </Carousel>
      </Container>
    </Box>
  )
}

export default HomeOffersList
